import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "pageCount", "currentPage", "getPageLink", "isLoading", "emptyContent", "stickyHeaderOffset", "mobileViewBreakpoint"];
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Card from 'components/Card';
import StickyBox from 'components/StickyBox';
import Table, { Column } from 'components/Table';
import Pagination from 'components/Pagination';
import { borderValue } from 'styles/mixins';
import { getSolidBackgroundShade, pxToRem } from 'utils/ui';
var tableRowHeight = 62;
var PaginationWrapper = styled(StickyBox).withConfig({
  displayName: "TableCard__PaginationWrapper",
  componentId: "sc-gudhjo-0"
})(["display:flex;align-items:center;min-height:", ";padding:", " ", ";background-color:", ";border-top:", ";border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;@media (max-width:", ") and (max-height:580px){position:relative !important;}"], pxToRem(tableRowHeight), function (p) {
  return p.theme.globals.spacing.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return borderValue(p.theme);
}, function (p) {
  return p.theme.globals.breakpoints.xs;
});
function TableCard(_ref) {
  var children = _ref.children,
    pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    getPageLink = _ref.getPageLink,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    emptyContent = _ref.emptyContent,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    mobileViewBreakpoint = _ref.mobileViewBreakpoint,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Card, {
    overflow: "visible"
  }, /*#__PURE__*/React.createElement(Table, _extends({}, otherProps, {
    emptyContent: isLoading ? /*#__PURE__*/React.createElement(Landmark, {
      icon: "spinner",
      height: 250
    }, t('loading')) : emptyContent,
    shadedHeader: true,
    rowMinHeight: tableRowHeight,
    stickyHeaderOffset: stickyHeaderOffset,
    mobileViewBreakpoint: mobileViewBreakpoint
  }), children), /*#__PURE__*/React.createElement(PaginationWrapper, {
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageCount: pageCount,
    currentPage: currentPage,
    getPageLink: getPageLink,
    desktopViewBreakpoint: mobileViewBreakpoint
  })));
}
export { Column };
export default TableCard;